import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderlineCancellationCauseIiem } from '@app/services/orderhead.service';

export interface OrderHeadCancelDialogData {
    cancellationCauses: OrderlineCancellationCauseIiem[];
}

export interface OrderHeadCancelDialogResult {
    orderlinecancelcause_keyno: string;
    cancellation_note: string;
}

@Component({
    selector: 'tt-order-head-cancel-dialog',
    templateUrl: './order-head-cancel-dialog.component.html',
    styleUrls: ['./order-head-cancel-dialog.component.css'],
})
export class OrderHeadCancelDialogComponent {
    public cause = '';

    public note = '';

    public cancellationCauses: OrderlineCancellationCauseIiem[] = [];

    constructor(
        public dialogRef: MatDialogRef<OrderHeadCancelDialogComponent, OrderHeadCancelDialogResult | undefined>,
        @Inject(MAT_DIALOG_DATA) data: OrderHeadCancelDialogData,
    ) {
        this.dialogRef.updateSize('min(60rem, 98vw)');
        this.cancellationCauses = data.cancellationCauses;
    }

    public confirm() {
        this.dialogRef.close({
            orderlinecancelcause_keyno: this.cause || '0',
            cancellation_note: this.note || '',
        });
    }
}
